<template>
  <a data-testid="toggle-favorite-off" :class="linkClass" @click="favoriteItem" href="#">
    <i :class="starClass"></i>
  </a>
</template>

<script>

// this component handles the favorite item requests using the yellow/gray star icon
// both in desktop item cards and viewer
export default {
  props: {
    itemId: Number,
    isFavorite: Boolean
  },
  data: function() {
    return {
      favorite: Boolean,
    }
  },
  computed: {
    starClass: function() { return !!this.favorite ? "fa-star fa yellow" : "fa-star far gray"; },
    linkClass: function() { return !!this.favorite ? "unfavorite-item" : "favorite-item"}
  },
  methods: {
    favoriteItem: function(){
      const vm = this;
      this.$store.dispatch('favoriteItem', this.itemId)
        .then((response) => {
          const favorite = response?.data?.data?.items[0]?.attributes?.favorite || !this.favorite;
          vm.favorite = favorite;
        })
        .catch((error) => {
          vm.$root.toastError('Could not favorite item, please try again.');
          console.log(error);}
        )
    },
  },
  created: function() {
    this.favorite = this.isFavorite;
  }
}
</script>
